<template>
  <div id="app">
    <!-- 路由组件出口 -->
      <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
	/* 微信二维码 */
/* 	href:data:text/css;base64,及base64加密后的地址（二维码样式）
	本例所加密内容： */
	 @charset "UTF-8";
	::v-deep .impowerBox .title { display: inherit }
	::v-deep .impowerBox .qrcode { width: 100%; }
	.impowerBox .js_wx_default_tip p:nth-child(2) { display: none }
	.impowerBox .icon38_msg.succ { background-size: 100%; background-position-y: -31px!important;}
	.impowerBox .icon38_msg { width: 26px; height: 27px; }
	
	/* 微信二维码 */
	::v-deep pre{
		width: 100%;
	}
	.richbox pre{
		width: 100%;
	}
	.richbox img{
			max-width:100% !important;
	}
	.richbox p{
		    line-height: 30px;
	}
	img{
		width: 100%;
		height: 100%;
	}
	
	.el-carousel__item h3{
		opacity: 1 !important;
	}
	.dialog_border  {
  border-radius: 19px !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f5f5f5;
  /* margin-top: 60px; */
}
@media only screen and (max-width: 768px){ /* 在小于等于768px的设备上执行该CSS代码 */
/* 	#appbox{
		zoom: 30%; 
	} */
	.vannav_title{
		font-size: 18px;
		font-weight: 600;
		color: #ffffff;
	}

}
	
/* 组件内容 */
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
	font-size: 19px;
	padding:7px;
	height: auto !important;
}
.el-select-dropdown__item.selected span{
	color: #1b9d57;
}
/* 组件内容 */
.top_gatebox{
	display: flex;
}
.gatebutton>a>button{
	    padding: 8px 15px !important;
}
.gatebutton {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 70px;
}
.plate_icon{
		width:70px;
		height: 70px;
	}
	.plate_icon img{
		
		width: 100%;
	}
	.plate_title{
		margin-top: 10px;
	}
	.plate_item{
		width: 340px;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border-left: 1px solid #ffffff;
		color: #ffffff;
		font-size: 22px;
		font-weight: 600;
	}
	.plate_item:hover{
		background: #cccccc38;
	}
	.plate_item:active{
		background:#0f6a8f36;
	}
	 .plate_item:first-child {
		 border-left: 0px solid #ffffff;
	  /* 父元素的第一个子元素的样式 */
	}
	.top_minemsgbox{
		width: 1230px;
		padding:10px 0px;
		/* height: 110px; */
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin: 0 auto;
		font-size: 15px;
		color:#606266;
		/* padding: 120px; */
	}
	.welcome{
		color:#187192;
		font-size: 16px;
		margin:0px 40px;
		/* flex: 1; */
		text-align: left;
		margin-right: 200px;
		
	}
	.top_right{
		display: flex;
		align-items: center;
	}
	.top_Mobiletype{
		padding: 4px 15px;
		background: #1b9d57;
		color: #ffffff;
		border-radius: 20px;
		margin-right: 10px;
		font-size: 14px;
		position: relative;
		    
	}
	.top_box{
		width: 1296px !important;
		justify-content: flex-start;
	}
	.Mobiletype_bubble{
		padding: 10px;
		background: #f5f7fa;
		position: absolute;
		z-index: 999;
		border-radius: 10px;
		left: -68px;
		top: 40px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
	.Mobiletype_bubble i{
		    color: #f5f7fa;
		    position: absolute;
		    top: -14px;
		    left: 84px;
		    margin: 0 auto;
			/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
		    font-size: 22px;
	}
	.logo_box{
		/* margin-right: 300px; */
	}
	.top_search_box{
		display: flex;
		align-items: center;
	}
	.top_search{
		display: flex;
		align-items: center;
		border: 1.5px solid #1b9d57;
		position: relative;
		padding: 6px 15px;
		border-radius: 60px;
		    margin: 0px 20px;
			font-size: 16px;
	}
	.top_search input{
		/* width: 200px; */
		color: #1b9d57;
	}
	.top_search i{
		font-size: 20px;
		font-weight: 600;
		color: #C0C4CC;
	}
	.top_search_icon{
		width: 64px !important;
		height: 64px !important;
		object-fit:contain;
		position: absolute;
		right: -10px;
		cursor: pointer;
	}
	.toptabnav{
		/* height: 70px !important; */
	/* 	background: #1b9d5700;
		position: absolute; */
		z-index: 99;
	}
	.top_tab_box{
		width: 100%;
		position: relative;
	}
	.top_banner{
		
	}
		
	.top_search_type{
		border-right: 1px solid #F2F6FC;
	}
	.top_plate{
		/* position: absolute; */
		/* bottom: 0px; */
		width: 100%;
		height: 164px;
		display: flex;
		justify-content: center;
		background: #1b9d57;
		z-index: 99;
	}
	.top_search_type>.el-input>input{
		border: 0px !important;
		font-size: 16px;
		color:#1b9d57;
	}
.top_heard{
		background-color: #ffffff;
		/* width: 1890px; */
	}
	.appbox{
		width: 100%;
	}
	.top_box{
		width: 1100px;
		height: 110px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0 auto;
	}
	.loginbox{
		display: flex;
		align-items: center;
		justify-content: center;
		color: #666;
		font-size: 14px;
	}
	.login{
		width: 40px;
		height: 34px;
		text-align: center;
		/* border-right: 1px solid #666; */
		line-height: 34px;
	
	}
	.register{
		width: 40px;
		height: 34px;
		text-align: center;
		line-height: 34px;
	}
	.logo_box img{
		width: 400px;
		height: 75px;
	}
	.toptabnav{
		display: flex;
		width: 100%;
		max-height: 70px;
		justify-content: center;
		align-items: center;
		background:#1b9d57;
	}
	.el-menu-demo{
		width: 1300px;
		font-size:20px;
		display: flex;
		justify-content: space-between;
	}
	.el-menu-demo .el-menu-item{
		font-size:20px;
		width: 150px;
		flex: 1;
		
	}
	.el-menu-demo .el-submenu{
		font-size:20px;
		width: 150px;
		flex: 1;
		
	}
	.el-menu-demo .el-submenu i{
		color: #ffffff;
		
	}
	.el-menu-demo .el-submenu>.el-submenu__title{
		font-size:20px;
		
	}
	.el-menu.el-menu--horizontal{
		border-bottom: 0px solid #1b9d57;
	}
	
	
	.pagesbottom_box{
			     background:#ffffff;
				  /* color: ; */
				  margin-top: 20px;
				  
	 }
	 .row{
			  width: 950px;
			  margin: 0 auto;
			  display: flex;
			  justify-content: space-between;
			  /* justify-content: flex-start; */
			  align-items: center;
			  padding-bottom: 30px;
	 }
	 .bottom_logo{
		 /* width: 565px; */
		 height: 100px;
	 }
	 .bottom_logo img{
		 width: 100% !important;
	 }
	 .copy-left{
			  /* margin-top: 15px; */
			  display: flex;
			      align-items: center;
			      justify-content: flex-start;
	 }
	 .copy-left p {
	     /* text-indent: 30px; */
	     /* margin-top: 10px; */
			  font-size: 28px;
	 }
	.copy-left p i {
	    margin-right: 20px;
	 }
	 .copy-right {
	     /* float: right; */
	     width: 180px;
	     text-align: center;
	     /* margin-bottom: 10px; */
	 }
	 .footer_box{
		background-color: #1b9d57;
		color: #fff !important;
		padding-top: 20px;
	 }
	 .bottom_right{
		 display: flex;
		
		 justify-content: center;
		 width: 100%;
		 align-items: flex-start;
		 margin-left: 50px;
	 }
	 .bottom_msg{
		 font-size: 14px;
		 /* color: #909399 !important; */
		 margin-bottom: 8px;
		 margin-right: 10px;
	 }
	 .bottom_msg a{
		 color: #fff !important;
	 }
	 .subnavbox{
		 margin: 20px;
		 margin-bottom: 0px;
		 border-left:1px solid #EBEEF5;
		 
	 }
	 .subtext_title{
		 font-size: 18px;
		 color: #303133;
		text-align: left;
		padding:0px 20px;
	 }
	 .subtexts{
	 	width: 950px;
	 	display: flex;
	 	margin: 0 auto;
	 	justify-content: space-between;
	 	margin-top: 50px;
	 	font-size: 16px;
	 	color:#606266;
	 	padding: 15px 0px;
		padding-bottom: 20px;
	 }
	 .copy-right p {
	     color: #fff;
	     height: 55px;
	     line-height: 80px;
	     overflow: hidden;
	     font-size: 20px;
	 }
	 .copy-right img {
	     width: 180px;
	     height: 180px;
		 /* margin: 10px; */
	     /* margin-top: 20px; */
	 }
	 .bottom_bottom{
		 display: flex;
		 justify-content: center;
		 align-items: center;
			      line-height: 45px;
			      background: #000;
			      text-align: center;
			      color: #DCDFE6;
	 }
	 .bottom_bottom a{
				margin-left: 16px;
			      background: #000;
			      /* text-align: center; */
			      color: #DCDFE6;
	 }
	 ::v-deep img{
	      max-width:100% !important;
	  }
	  .richbox{
	  	padding: 20px;
	  	font-size: 16px;
	  	text-align: left;
	  }
	  ::v-deep table{
		   max-width:100% !important;
	  }
	  .richbox table{
		   max-width:100% !important;
	  }
	  .swim_box{
		  width: 190px;
		  padding: 10px;
		  position: fixed;
		  right: 100px;
		  top: 220px;
		  display: flex;
		  flex-direction: column;
		  align-items: center;
		  justify-content: center;
		  background: #ffffff;
		  border-radius: 10px;
		  z-index: 999;
	  }
	  .swim_title{
		font-size: 18px;
		font-weight: 600;
		font-family: fangsong;
	  }
	  .swim_code{
		  width: 180px;
		  height: 180px;
		  margin-top: 10px;
	  }
	  .swim_code img{
		  width: 100%;
		  height: 100%;
	  }
	  
	  /* 侧边栏 */
	  .navbar {
	      text-align: center;
	      background-color: white;
	      position: fixed;
		      top: calc(68% - 60px);
	      
	      right: 2%;
	      width: 55px;
	      /* min-height: 220px; */
	      z-index: 999;
	      border-radius: 5px;
	  }
	  .navbar-top{
	      text-align: center;
	      background-color: white;
	      position: fixed;
	       top: calc(68% - 60px);
	      right: 2%;
	      width: 55px;
	      /* min-height: 165px; */
	      z-index: 999;
	      border-radius: 5px;
	  }
	  .navbar a {
	      color: #0b698d;
	      text-decoration: none;
	      width: 100%;
	      height: 55px;
	      display: block;
	      font-size: 30px;
	      padding-top: 5px;
	  }
	  .navbar a:last-child{
	      color: #0b698d;
	      text-decoration: none;
	      width: 100%;
	      height: 55px;
	      display: block;
	      font-size: 15px;
	      border-radius: 0px 0px 5px 5px;
	  }
	  .navbar a:first-child{
	      color:#0b698d;
	      text-decoration: none;
	      width: 55px;
	      height: 55px;
	      display: block;
	      font-size: 30px;
	      border-radius: 5px 5px 0px 0px;
	  }
	  .navbar a:hover {
	      background-color: #1b9d57;
	      color: white;
	  }
	  .navbar-top a {
	      color: #0b698d;
	      text-decoration: none;
	      width: 100%;
	      height: 55px;
	      display: block;
	      font-size: 30px;
	      padding-top: 5px;
	  }
	  .navbar-top a:last-child{
	      color: #0b698d;
	      text-decoration: none;
	      width: 100%;
	      height: 55px;
	      display: block;
	      font-size: 30px;
	      border-radius: 0px 0px 5px 5px;
	  }
	  .navbar-top a:first-child{
	      color: #0b698d;
	      text-decoration: none;
	      width: 55px;
	      height: 55px;
	      display: block;
	      font-size: 30px;
	      border-radius: 5px 5px 0px 0px;
	  }
	  .navbar-top a:hover {
	      background-color: #1b9d57;
	      color: white;
	  }
	  .qrShow{
	      position: fixed;
	      top: calc(68% + 80px);
	      right: calc(3% + 60px);
	      z-index: 999;
	      background-color: #1b9d57;
	      width: 110px;
	      height: 110px;
	      color: white;
	      text-align: center;
	      border-radius: 5px;
	      font-family: sans-serif;
	      padding-top: 5px;
	  }
	  .qrShow:after {
	      content: "";
	      position: absolute;
	      width: 0;
	      height: 0;
	      border: 8px solid;
	  }
	  .qrShow2{
	      position: fixed;
	      top: calc(68% + 30px);
	      right: calc(3% + 60px);
	      z-index: 999;
	      background-color: #1b9d57;
	      width: 110px;
	      height: 110px;
	      color: white;
	      text-align: center;
	      border-radius: 5px;
	      font-family: sans-serif;
	      padding-top: 5px;
	  }
	  .qrShow2:after {
	      content: "";
	      position: absolute;
	      width: 0;
	      height: 0;
	      border: 8px solid;
	  }
	  .qrShow3{
	      position: fixed;
	      top: calc(68% - 30px);
	      right: calc(3% + 60px);
	      z-index: 999;
	      background-color: #1b9d57;
	      width: 110px;
	      height: 110px;
	      color: white;
	      text-align: center;
	      border-radius: 5px;
	      font-family: sans-serif;
	      padding-top: 5px;
	  }
	  .qrShow3:after {
	      content: "";
	      position: absolute;
	      width: 0;
	      height: 0;
	      border: 8px solid;
	  }
	  .right:after {
	      border-left-color: rgb(179, 179, 179);
	      left: 100%;
	      top: 50%;
	      margin-top: -7px;
	  }
	  .right2:after {
	      border-left-color: rgb(179, 179, 179);
	      left: 100%;
	      top: 50%;
	      margin-top: -7px;
	  }
	  /* 分站点相关 */
	  .Site_switch{
	  		  /*position: absolute;
	  		  left: 100px;
	  		  top:calc( 55px - 19px);*/
	  		  padding: 2px 10px;
	  		  border: 1.5px solid #1b9d57;
	  		border-radius: 60px;
	  }
	  .manage_switch{
		  padding: 2px 10px;
		    border: 1.5px solid #1b9d57;
		  border-radius: 60px;
	  }
	  .Site_switch_type>.el-input>input{
	  		  border: 0px !important;
	  		  font-size: 16px;
	  		  color: #1b9d57;
	  }
</style>
